<template>
    <div>
		<Card :bordered="false" :dis-hover="true">
			<transition name="fade">
				<Row v-if="mainTable.sarchCardShow" :gutter="16">
					<Col span="24">
					<search-card :form="mainTable.searchForm" 
                        :table-load-event="getMainTableRecords"
						:table-search="mainTable.tableSearch"
                        :colSpan="4" />
					</Col>
				</Row>
			</transition>
			<Row :gutter="16">
				<Col span="24">
                    <div class="global-tool-bar">
                        <div class="left-bar">
                            <span class="title">违约单管理</span>
                        </div>
                        <div class="right-bar">
                            <Button type="primary" size="small" class="btns" shape="circle" icon="ios-search"
                                @click="mainTable.sarchCardShow = !mainTable.sarchCardShow">搜索</Button>
                            <Button type="primary" size="small" class="btns" shape="circle" icon="ios-search"
                                @click="onExport">导出</Button>
                        </div>
                    </div>
				</Col>
			</Row>
			<Row :gutter="16" class="main">
                <Col span="24">
                    <stand-pagination-table 
                        :columns="mainTable.columns"
                        :data="mainTable.data"
                        :loading="mainTable.loading"
                        :table-search="mainTable.tableSearch"
                        :table-load-event="getMainTableRecords"
                        :autoHeight = "true"
                        summaryLabelField = "ownerUsername"
                        :summaryFields="['liquidatedDamagesQuantity', 'liquidatedDamagesTotalAmount']"
                        :totalSummaryFieldDatas="mainTable.sumData"
                        :showPage="true" />
                </Col>
            </Row>
		</Card>
		<LiquidatedDamageDetailModal ref="liquidatedDamageDetailModal"/>
        <AuditModal ref="auditModal" @audit="audit"/>
	</div>
</template>

<script>
import SearchCard from '@/components/searchCard/searchCard.vue';
import search from '@/libs/search';
import StandPaginationTable from '@/components/pagination-table/pagination-table.vue';
import { getThisMonthStart, getTodayDateString } from '@/libs/logic';
import { numberToFixed, number2ThousandsFormat } from '@/components/number-input/display-format';
import { dateTimeRender, dateRender } from '@/libs/tableRowTimeRender';
import { BILL_TYPE, BILL_AUDIT, BREACHING_PARTY_NAME, SEEDFARM, CUSTOMER, BREACHING_PARTY_NAME_OPTION, TYPE_OPTION } from '@/view/common/liquidated-damage';
import { SAVE, SUBMIT, PASS, REJECT, AUDIT_STATUS, STATUS_COLORS, AUDIT_STATUS_OPTION } from '@/view/common/audit.js';
import { getLiquidatedDamageList, auditLiquidatedDamage, delLiquidatedDamage, submitLiquidatedDamage, exportLiquidatedDamage } from '@/api/modules/liquidated-damage/liquidated-damage';
import { UPLOAD_FILE_API, DOWNLOAD_SERVER } from '@/api/modules/files';
import LiquidatedDamageDetailModal from '@/view/preSale-management/liquidated-damage/liquidated-damage-detail.vue';
import AuditModal from '@/view/modal/audit-modal.vue';
import { } from '@/view/common/audit';
export default {
    name: 'LiquidatedDamageOrder',
    components: {
        StandPaginationTable,
        SearchCard,
        LiquidatedDamageDetailModal,
        AuditModal
    },
    data() {
        return {
            BREACHING_PARTY_NAME,
            SEEDFARM, 
            CUSTOMER,
            selectDates: [],
            mainTable: {
                columns: [
                    {
                        title: '违约单号',
                        key: 'liquidatedDamagesCode',
                        align: 'center',
                        width: 150
                    },
                    {
                        title: '会员账号',
                        key: 'ownerName',
                        align: 'center',
                        width: 80
                    },
                    {
                        title: '会员名称',
                        key: 'ownerUsername',
                        align: 'center'
                    },
                    {
                        title: '会员电话',
                        key: 'ownerUserPhone',
                        align: 'center',
                        width: 80
                    },
                    /* {
                        title: '单据类型',
                        key: 'billType',
                        align: 'center',
                        width: 100,
                        render: (h, params) => {
                            const { billType } = params.row;
                            return h('div', {}, [
                                h('span', {}, BILL_TYPE[billType])
                            ]);
                        }
                    }, */
                    {
                        title: '违约方',
                        key: 'ownerName',
                        align: 'center',
                        width: 60,
                        render: (h, params) => {
                            const { breachingParty } = params.row;
                            return h('div', {}, [
                                h('span', {}, breachingParty==BREACHING_PARTY_NAME[CUSTOMER]?CUSTOMER:SEEDFARM)
                            ]);
                        }
                    },
                    {
                        title: '违约类型',
                        key: 'type',
                        align: 'center',
                        width: 60,
                        render: (h, params) => {
                            const { type } = params.row;
                            return h('div', {}, [
                                h('span', {}, type?"部分":"全部")
                            ]);
                        }
                    },
                    {
                        title: '关联定金单号',
                        key: 'liquidatedDamagesRelateRecordCode',
                        align: 'center',
                        width: 150
                    },
                    {
                        title: '数量',
                        key: 'liquidatedDamagesQuantity',
                        align: 'center'
                    },
                    {
                        title: '违约金额',
                        key: 'liquidatedDamagesTotalAmount',
                        align: 'center'
                    },
                    {
                        title: '制单人',
                        key: 'createUserName',
                        align: 'center'
                    },
                    {
                        title: '制单时间',
                        key: 'createdTime',
                        align: 'center',
                        render: (h, params) => dateTimeRender(h, params.row.createdTime)
                    },
                    {
                        title: '备注',
                        key: 'liquidatedDamageRemark',
                        align: 'left'
                    },
                    {
                        title: '审核状态',
                        key: 'auditStatus',
                        align: 'center',
                        width: 60,
                        render: (h, params) => {
                            const { auditStatus } = params.row;
                            // 根据状态值获取对应的颜色
                            const color = STATUS_COLORS[auditStatus] || 'black'; // 默认黑色
                            return h('div', {}, [
                                h('span', { style: { color: color } }, BILL_AUDIT[auditStatus])
                            ]);
                        }
                    },
                    {
                        title: '审核时间',
                        key: 'auditTime',
                        align: 'center',
                        render: (h, params) => dateTimeRender(h, params.row.auditTime)
                    },
                    {
                        title: '审核备注',
                        key: 'auditRemark',
                        align: 'center'
                    },
                    {
                        title: '操作',
                        key: 'action',
                        align: 'center',
                        width: 60,
                        render: (h, params) => {
                            const { liquidatedDamagesUuid, billType, auditStatus, liquidatedDamagesRelateRecordId, liquidatedDamagesRelateRecordCode } = params.row;
                            if (params.row.action === -1) {
                                return "";
                            }
                            else {
                                return h('div', [
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                        },
                                        on: {
                                            click: () => {
                                                this.$refs.liquidatedDamageDetailModal.showModal("view", billType, liquidatedDamagesRelateRecordId, liquidatedDamagesRelateRecordCode, liquidatedDamagesUuid);
                                            }
                                        }
                                    }, '查看'),
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                            //display: this.$checkAccessArray(['G']) ? 'inline' : 'none'
                                            display: this.$checkAccessArray(['G']) && [SAVE, REJECT].includes(auditStatus) || this.$checkAccessArray(['B']) && [SUBMIT].includes(auditStatus) ? 'inline' : 'none'
                                        },
                                        on: {
                                            click: () => {
                                                this.$refs.liquidatedDamageDetailModal.showModal('handle', billType, liquidatedDamagesRelateRecordId, liquidatedDamagesRelateRecordCode, liquidatedDamagesUuid);
                                            }
                                        }
                                    }, '处理'),
                                    /* h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                            display: this.$checkAccessArray(['G']) && (auditStatus == SAVE 
                                                        || auditStatus == REJECT)
                                                ? 'inline' : 'none'
                                        },
                                        on: {
                                            click: () => {
                                                this.$refs.liquidatedDamageDetailModal.showModal("edit", billType, liquidatedDamagesRelateRecordId, liquidatedDamagesRelateRecordCode, liquidatedDamagesUuid);
                                            }
                                        }
                                    }, '编辑'), */
                                    /* h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                            display: this.$checkAccessArray(['G']) && (auditStatus == SAVE 
                                                        || auditStatus == REJECT )
                                                ? 'inline' : 'none'
                                        },
                                        on: {
                                            click: () => {
                                                this.submit(liquidatedDamagesUuid);
                                            }
                                        }
                                    }, '提交'), */
                                    /* h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style:{
										    display: this.$checkAccessArray(['B']) && auditStatus == SUBMIT? 'inline' : 'none',
									    },
                                        on: {
                                            click: () => {
                                                this.$refs.auditModal.showModal(liquidatedDamagesUuid);
                                            }
                                        }
                                    }, '审核'), */
                                    h('Button', {
                                        props: {
                                            type: 'text',
                                            size: 'small',
                                            shape: 'circle'
                                        },
                                        style: {
                                            display: this.$checkAccessArray(['G']) && (auditStatus == SAVE 
                                                        || auditStatus == REJECT)
                                                ? 'inline' : 'none'
                                        },
                                        on: {
                                            click: () => {
                                                this.deleteLiquidatedDamage(liquidatedDamagesUuid);
                                            }
                                        }
                                    }, '删除')
                                ]);
                            }
                        }
                    }
                ],
                data: [],
                sumData: [],
                sarchCardShow: false,
                searchForm: [
                    { label: '违约单号', type: 'Input', value: '', name: 'liquidatedDamagesCode', sql: 'like' },
                    { label: '定金单号', type: 'Input', value: '', name: 'depositBillRecordCode', sql: 'like' },
                    { label: '违约方', type: 'Select', name: 'breachingParty', value: [], sql: 'in', options: BREACHING_PARTY_NAME_OPTION },
                    { label: '违约类型', type: 'Select', name: 'type', value: [], sql: 'in', options: TYPE_OPTION },
                    { label: '制单时间', type: 'Daterange', value: '', name: 'ld.createdTime', sql: 'dateBetween' },
                    { label: '会员信息', type: 'Input', value: '', name: 'CONCAT(op.userName, op.userPersonName, op.userPhone)', sql: 'like' },
                    { label: '会员电话', type: 'Input', value: '', name: 'op.userPhone', sql: 'like' },
                    { label: '审核时间', type: 'Daterange', value: '', name: 'ld.auditTime', sql: 'dateBetween' },
                    { label: '审核状态', type: 'Select', name: 'auditStatus', value: [], sql: 'in', options: AUDIT_STATUS_OPTION },
                    { label: '苗场信息', type: 'Input', value: '', name: 'CONCAT(sf.seedFarmCode, sf.seedFarmName)', sql: 'like' }

                ],
                loading: false,
                tableSearch: search.getSearchParams()
            }
        };
    },
    computed: {},
    mounted() {
        let beginDate = this.getThisMonthStart();
        let endDate = this.getTodayDateString();
        this.selectDates = [beginDate, endDate];
        this.init();
    },
    methods: {
        getTodayDateString,
        getThisMonthStart,
        init(){
            this.getLiquidatedDamage();
        },
        getMainTableRecords(){
            this.getLiquidatedDamage();
        },
        getLiquidatedDamage(reset = false){
            this.mainTable.loading = true;
            if (reset) {
                search.globalResetSearch(this.mainTable.tableSearch);
            }
            this.mainTable.tableSearch.needExport = 0;
            this.mainTable.tableSearch.groupBy = this.groupBy;
            this.mainTable.tableSearch.beginDate = this.selectDates[0];
            this.mainTable.tableSearch.endDate = this.selectDates[1];
            getLiquidatedDamageList(this.mainTable.tableSearch).then(res => {
                if (res.code === 0) {
                    this.mainTable.data = res.data.records;
                    this.mainTable.sumData = res.data.sumRecord;
                    search.globalSetFilterRecordCount(this.mainTable.tableSearch, res.data.filterRecordCount);
                }
                this.mainTable.loading = false;
            });
        },
        deleteLiquidatedDamage(id){
            this.mainTable.loading = true;
            delLiquidatedDamage({ liquidatedDamagesUuid: id }).then(res=>{
                if (res.code === 0) {
                    this.getLiquidatedDamage();
                }
                this.mainTable.loading = false;
            });
        },
        audit(status, remark, id){
            let auditStatus = status == "通过" ? status = PASS : REJECT;
            this.mainTable.loading = true;
            auditLiquidatedDamage({ liquidatedDamagesUuid: id, auditStatus: auditStatus, aditRemark: remark }).then(res => {
                if (res.code === 0) {
                    this.getLiquidatedDamage();
                }
                this.mainTable.loading = false;
            });
        },
        submit(id){
            this.mainTable.loading = true;
            submitLiquidatedDamage({ liquidatedDamagesUuid: id }).then(res=>{
                if (res.code === 0) {
                    this.getLiquidatedDamage();
                }
                this.mainTable.loading = false;
            });
        },
        onExport(){
            this.mainTable.tableLoading = true;
            this.btnLoading = true;
            exportLiquidatedDamage(this.mainTable.tableSearch).then(res => {
                this.btnLoading = false;
                this.mainTable.tableLoading = false;
                if (res.code === 0) {
                    if (res.code === 0) {
                        let url = DOWNLOAD_SERVER + res.data.exportFileName;
                        this.$downLoadFile(url);
                    }
                }
            });
        }
    }
};
</script>

<style>
</style>